import type { WorkTypeCode } from "../api/types";
import { WORK_TYPES } from "../workflow/workTypes";
import { WorkTypeIcon } from "./WorkTypeIcon";

/**
 * Coloured pictogram tile + label (UX-01 3.2, GRF-10). Never colour alone: every type has its own shape, and the label
 * is always in the accessible name. On dense cards the label is visually hidden but still read, and shown as a
 * hover tooltip.
 */
export function WorkTypeTile({ type, hideLabel = false }: { type: WorkTypeCode; hideLabel?: boolean }) {
  const info = (WORK_TYPES as Partial<Record<string, (typeof WORK_TYPES)[WorkTypeCode]>>)[type];
  const label = info?.label ?? type;
  return (
    <span className="gf-type" data-work-type={type} title={hideLabel ? label : undefined}>
      <i className={info?.register ? "raid" : undefined} style={info?.register ? undefined : { background: info?.tone ?? "var(--gray-t)" }} aria-hidden="true">
        <WorkTypeIcon type={type} />
      </i>
      <span className={hideLabel ? "vh" : undefined}>{label}</span>
    </span>
  );
}
